import React, { Component } from 'react';
import moment from 'moment';

import { defaultSorter, dateSorter } from './Helpers';

import { Table, Badge } from 'antd';

class TrafficSignsLogsTable extends Component {

  state = {
    children: [],
    filteredInfo: {},
    sortedInfo: {}
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter,
    });
  }

  render() {
    let { sortedInfo, filteredInfo } = this.state;

    const columns = [{
      title: 'Seriové číslo',
      dataIndex: 'serialNumber',
      key: 'serialNumber',
      width: 150,
      sorter: (a, b) => defaultSorter(a.serialNumber, b.serialNumber),
    }, {
      title: 'Popis',
      dataIndex: 'description',
      key: 'description',
      width: 500,
    }, {
      title: 'Čas',
      dataIndex: 'timestamp',
      key: 'timestamp',
      width: 150,
      defaultSortOrder: 'descend',
      sorter: (a, b) => dateSorter(a.timestamp, b.timestamp),
      render: (text, record) => (
        <span>{text ? moment(text).format('L LTS') : null}</span>
      ),
    }, {
      title: 'Čas přijetí',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 150,
      sorter: (a, b) => dateSorter(a.createdAt, b.createdAt),
      render: (text, record) => (
        <span>{text ? moment(text).format('L LTS') : null}</span>
      ),
    }, {
      title: 'Druh zprávy',
      dataIndex: 'type',
      key: 'type',
      width: 140,
      filters: [
        { text: 'INFO', value: 'INFO' },
        { text: 'WARN', value: 'WARN' },
        { text: 'ERROR', value: 'ERROR' },
      ],
      filteredValue: filteredInfo.type || null,
      onFilter: (value, record) => { return (record.type == value) ? true : false },
      render: (text, record) => {
        if (text === 'INFO') {
          return <Badge status="info" text="INFO" />
        } else if (text === 'WARN') {
          return <Badge status="warning" text="WARN" />
        } else if (text === 'ERROR') {
          return <Badge status="error" text="ERROR" />
        } else {
          return text;
        }
      }
    }, {
      title: 'Text',
      dataIndex: 'text',
      key: 'text'
    }]

    return (
      <Table
        size='small'
        rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
        loading={this.props.loading ? this.props.loading : false}
        columns={columns}
        dataSource={this.props.data}
        style={{ border: '0px' }}
        pagination={{
          showSizeChanger: true,
          defaultPageSize: localStorage.getItem('table_pageSize') !== undefined
            ? parseInt(localStorage.getItem('table_pageSize'))
            : 10,
          onShowSizeChange: (current, size) => {
            localStorage.setItem('table_pageSize', size);
          }
        }}
        onChange={this.handleChange} />
    );
  }
}

export default TrafficSignsLogsTable;



// WEBPACK FOOTER //
// ./src/components/TrafficSignsLogsTable.js